import { render, staticRenderFns } from "./VideoReports.vue?vue&type=template&id=70cb350d"
import script from "./VideoReports.js?vue&type=script&lang=js&external"
export * from "./VideoReports.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports